var _path, _rect, _rect2, _path2, _rect3, _path3, _rect4, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse1Floor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71094 16.9404H61.9718V36.8535H56.1457V21.897H42.9283V36.8535H5.71094V16.9404Z",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.1304,
    height: 4.95652,
    transform: "matrix(1 0 0 -1 1.79785 41.8098)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.5652,
    height: 11.7391,
    transform: "matrix(1 0 0 -1 42.8418 12.7664)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8413 6.41869H8.75437L1.79785 16.9404H65.7979L58.8413 6.41869H54.4065",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.65217,
    height: 4.95652,
    transform: "matrix(1 0 0 -1 56.1455 41.8098)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.624 41.8098H56.4936",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16.7826,
    height: 9.08696,
    transform: "matrix(1 0 0 -1 12.8086 31.0273)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2002 31.0273V21.9404",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 31.0273L32.3412 31.0273",
    stroke: "#808080",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse1Floor);
export default __webpack_public_path__ + "static/media/house_1floor.0f47df13affa5aa6354cfe1cb34fb7a3.svg";
export { ForwardRef as ReactComponent };